import { LOAD_STATE } from '@/shared/types'
import type { RelativeComplaintRankResponse } from '@/server/types'
import { getRelativeComplaintRankApi } from '@/server'

export function logicHotCollectiveRank() {
  const state = ref(LOAD_STATE.INIT)
  const data = ref<RelativeComplaintRankResponse[]>([])

  async function getRankData(params: { seriesId: string | number }) {
    const res = await useLoadState({
      state,
      key: `相关投诉`,
      onlyClient: true,
      fn: () => getRelativeComplaintRankApi(params),
    })

    if (res && res.data)
      data.value = res.data
  }

  return {
    state,
    data,
    getRankData,
  }
}
